import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from 'antd';
import * as S from './styles';
import Button from '../../atoms/Button';

function TermosConsentimentoCotacao({
  seguroSelecionado,
  pageLoading,
  dadosPessoais,
  enviarAceite,
  onSolicitarCotacao,
  onAlterarDadosPessoais,
  // onAlterarSeguroSelecionado,
}) {
  const { lgpdChecked } = dadosPessoais;
  const [aceiteConcedido, setAceiteConcedido] = useState(lgpdChecked);

  useEffect(() => {
    setAceiteConcedido(lgpdChecked);
  }, [lgpdChecked]);

  const requiredFields = ['nomeUsuario', 'cpf', 'email', 'nomeCompleto'];

  const missingField = requiredFields.find((field) => !dadosPessoais[field]);
  if (missingField) {
    return (
      <S.TabTermos>
        <p>
          <strong>Não foram obtidos os parâmetros necessários para liberar acesso a cotação.</strong>
        </p>
      </S.TabTermos>
    );
  }

  return (
    <S.TabContent>
      <h3>{seguroSelecionado.nome}</h3>

      <p>{seguroSelecionado.descricao}</p>

      {(seguroSelecionado.id === 'vida' || seguroSelecionado.id === 'dit') && (
        <p>
          Detalhes dos Planos sobre {seguroSelecionado.nome} consulte nosso portfólio ou
          <Button
            type="link"
            style={{ padding: '2px' }}
            onClick={() => onAlterarDadosPessoais({ ...dadosPessoais, exibeTabelaPlanos: true })}
          >
            veja aqui.
          </Button>
        </p>
      )}

      {pageLoading ? (
        <div style={{ padding: '0 40px' }}>
          <Skeleton
            paragraph={{ rows: 1 }}
            active
            title
          />
        </div>
      ) : (
        <>
          <S.TabTermos>
            <input
              type="checkbox"
              id="lgpd"
              name="lgpd"
              value={aceiteConcedido}
              checked={aceiteConcedido}
              onChange={() => setAceiteConcedido(!aceiteConcedido)}
            />
            <label htmlFor="lgpd">
              Aceitar termos de{' '}
              <a
                href="https://storage.googleapis.com/static-files-4fdd9378-835d-40e4-b124-36699ae5cc08/seguros/politica-privacidade/politica.pdf"
                target="_blank"
                rel="noreferrer"
              >
                Política de Privacidade e Segurança de Dados
              </a>
            </label>
          </S.TabTermos>

          <S.ButtonsTabs>
            <Button
              disabled={!aceiteConcedido}
              onClick={() => onSolicitarCotacao()}
            >
              Planos Personalizados
            </Button>

            {/*
              @TODO: HABILITAR_SIMULADOR_SAUDE tag para marcar os locais relacionados

              Foi removido o acesso aos simuladores de saúde.
              Possivelmente vão retornar em algum momento, por
              isso ainda decidimos manter o código e não removê-lo
            */}
            {/* {seguroSelecionado.id === 'saude' && (
              <Button onClick={() => onAlterarSeguroSelecionado({ id: 'unimed' })}>
                Simulador Saúde
              </Button>
            )} */}

            {lgpdChecked && (
              <Button
                type="link"
                onClick={() => enviarAceite(false)}
              >
                Cancelar Cadastro
              </Button>
            )}
          </S.ButtonsTabs>
        </>
      )}

      {seguroSelecionado.seguradoras && seguroSelecionado.seguradoras.length > 0 && (
        <div>
          <p>Seguradora:</p>

          {seguroSelecionado.seguradoras.map((seguradora) => (
            <S.Logo
              src={seguradora}
              alt="Logo seguradora"
              key={seguradora}
            />
          ))}
        </div>
      )}
    </S.TabContent>
  );
}

TermosConsentimentoCotacao.propTypes = {
  seguroSelecionado: PropTypes.shape({
    id: PropTypes.string,
    nome: PropTypes.string,
    descricao: PropTypes.string,
    seguradoras: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  pageLoading: PropTypes.bool.isRequired,
  dadosPessoais: PropTypes.shape({
    lgpdChecked: PropTypes.bool,
    nomeUsuario: PropTypes.string,
    cpf: PropTypes.string,
    email: PropTypes.string,
    nomeCompleto: PropTypes.string,
  }).isRequired,
  enviarAceite: PropTypes.func.isRequired,
  onSolicitarCotacao: PropTypes.func.isRequired,
  onAlterarDadosPessoais: PropTypes.func.isRequired,
  // onAlterarSeguroSelecionado: PropTypes.func.isRequired, --- IGNORE ---
};

export default TermosConsentimentoCotacao;
